import React, {Component} from 'react';

class Footer extends Component {

	render() {
		return (
			<footer id="footer">
				<span>&copy; 2018, 2022 Dogpoint o.p.s.</span>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js